<p><b>Обычный с подсказкой</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-textarea 
          formControlName="counter" 
          label="Текстовое поле" 
          tooltip="Текст подсказки"
          placeholder="Введите текст"
          hint="Подсказка"
          [maxLength]="150"
          ></pa-textarea>
    </form>
</div>

<p><b>Без счетчика символов</b></p>
<div class="box">
    <form [formGroup]="form">
        <pa-textarea 
          formControlName="counter2" 
          label="Текстовое поле" 
          tooltip="Текст подсказки"
          placeholder="Введите текст"
          hint="Подсказка"
          ></pa-textarea>
    </form>
</div>

<p><b>Кастомные сообщения ошибок</b></p>
<div class="box">
    <form [formGroup]="form2">
        <pa-textarea 
          formControlName="counter" 
          label="Текстовое поле" 
          tooltip="Текст подсказки"
          placeholder="Введите текст"
          [customErrorMessages]="textareaErrorMessages"
        ></pa-textarea>
    </form>
</div>